import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Container, LabelContainer, Label, InputContainer, Input, Error,
} from './css';
import ViewPassword from '../../../../assets/icons/ViewPassword.svg';
import HidePassword from '../../../../assets/icons/HidePassword.svg';

const PasswordInput = ({
  input,
  label,
  errorMessage,
  placeholder,
  disabled,
  meta: { touched, error } = {},
  tooltip,
}) => {
  const [isHidden, setIsHidden] = useState(true);

  return (
    <Container>
      <LabelContainer>
        <Label>{label}</Label>
        {tooltip && tooltip}
      </LabelContainer>

      <InputContainer>
        <Input
          {...input}
          type={isHidden ? 'password' : 'text'}
          autoComplete="off"
          placeholder={placeholder}
          disabled={disabled}
        />
        <img
          src={isHidden ? ViewPassword : HidePassword}
          onClick={() => setIsHidden(!isHidden)}
          alt={isHidden ? 'Show password' : 'Hide password'}
          aria-hidden="true"
        />
      </InputContainer>

      {((touched && error) || errorMessage) && (
        <Error>{error || errorMessage}</Error>
      )}
    </Container>
  );
};

PasswordInput.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
    value: PropTypes.string,
  }),
  label: PropTypes.string,
  errorMessage: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  tooltip: PropTypes.node,
};

export default PasswordInput;
